import { useCallback, useEffect, useState } from "react";
import { fetchCompanyBeneficiaries } from "../api/companyApi";
import { enterpriseBeneficiaries } from "../data";
import type { Beneficiary } from "../types";
import { getAuthToken } from "../auth";

function mapDemoBeneficiary(beneficiary: Beneficiary): Beneficiary {
  return beneficiary;
}

function mapApiBeneficiary(row: {
  id: string;
  name: string;
  relation: string;
  matricule: string;
  company_matricule: string;
  company: string;
  photo: string;
}): Beneficiary {
  return {
    id: row.id,
    recordId: row.record_id,
    beneficiaryType: row.type,
    photo: row.photo,
    name: row.name,
    relation: row.relation,
    birthDate: "",
    age: "",
    gender: "",
    employee: "",
    matricule: row.matricule,
    companyMatricule: row.company_matricule,
    company: row.company,
    status: "active",
  };
}

export function useEnterpriseBeneficiaries() {
  const [beneficiaries, setBeneficiaries] = useState<Beneficiary[]>(() =>
    enterpriseBeneficiaries.map(mapDemoBeneficiary),
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [usingApi, setUsingApi] = useState(false);
  const [total, setTotal] = useState(enterpriseBeneficiaries.length);

  const load = useCallback(async () => {
    if (!getAuthToken()) {
      setUsingApi(false);
      setBeneficiaries(enterpriseBeneficiaries.map(mapDemoBeneficiary));
      setTotal(enterpriseBeneficiaries.length);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    setUsingApi(true);

    try {
      const rows = await fetchCompanyBeneficiaries();
      const mapped = rows.map(mapApiBeneficiary);
      setBeneficiaries(mapped);
      setTotal(mapped.length);
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Impossible de charger les bénéficiaires.";
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { beneficiaries, total, loading, error, usingApi, reload: load };
}
